import React, { useEffect, useState } from 'react';
import { SlidingStatBar } from 'app/member/layouts/sliding/sliding';
import { PrimaryStatCard } from 'app/shared/cards';
import { useMobilePushLogService } from 'hooks/messaging/mobile/log';

export const WebPushMessageStatBar = ({ id }) => {
  const { fetchLogs } = useMobilePushLogService();

  const [logs, setLogs] = useState({});

  useEffect(() => {
    if (!id) return;
    Promise.all([
      fetchLogs({ query_string: `resource_id=${id}&status=sent&count=1` }),
      fetchLogs({ query_string: `resource_id=${id}&status=opened&count=1` })
    ]).then(([{ size: sent }, { logs: opened }]) => {
      setLogs((curr_logs) => ({
        ...curr_logs,
        sent,
        opened
      }));
    });
  }, [id]);

  return (
    <>
      <SlidingStatBar>
        <PrimaryStatCard
          main_stat={{
            label: 'Sent',
            value: logs.sent,
            color: 'var(--blue-primary)'
          }}
          bottom_stat={{ label: '-', value: '-' }}
        />
        <PrimaryStatCard
          main_stat={{
            label: 'Opened',
            value: logs.opened,
            color: 'var(--green-primary)'
          }}
          bottom_stat={{ label: '-', value: '-' }}
        />
      </SlidingStatBar>
    </>
  );
};
